import React, { useState, useEffect, useRef } from "react"
import { getMainUrl, getPaymentMode } from "../../../services/api";
import { postPagoTassaPagoPa,postPagoTassaPagoPaModelloTre } from "../../../services/endpoints";
import { showProgress, showSpinner } from "../../../utils/elements";
import { formatScadenza } from "../../../utils/format";
import * as Validator from "../../../utils/validator";
import * as Constants from '../../../utils/constants'
import { getUrlEsitoPagamento } from '../../../utils/utilities'
import {
  Container,
  Row,
  Col,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Alert,
  Popover,
  PopoverHeader,
  PopoverBody
} from 'design-react-kit';

export const SibaPrenotaPagamento = ({ _tipoVeicolo, _targa, _codiceFiscale, _calcolo, _email, _handleEmailChange, _authMode }) => {

  const [email, setEmail] = useState(_email);
  const [prenotazionePagamento, setPrenotazionePagamento] = useState(undefined);
  const [isLoading, setLoading] = useState(false);
  const [error,setError] = useState(undefined)
  const [pdfAvviso,setPdfAvviso] = useState(false)
  const [urlStampa,setUrlStampa] = useState(undefined)

  useEffect(() => {
    const pagamentoForm = document.getElementById("pagamentoForm");
    if (pagamentoForm &&
      pagamentoForm.elements["alias"] &&
      pagamentoForm.elements["importo"] &&
      pagamentoForm.elements["codTrans"] &&
      pagamentoForm.elements["divisa"] &&
      pagamentoForm.elements["url"] &&
      pagamentoForm.elements["url_back"] &&
      pagamentoForm.elements["urlpost"] &&
      pagamentoForm.elements["mac"] &&
      pagamentoForm.elements["identificativoFiscalePagatore"] &&
      pagamentoForm.elements["tipoPagatore"] &&
      pagamentoForm.elements["anagraficaPagatore"] &&
      pagamentoForm.elements["mail"] &&
      pagamentoForm.elements["urlAction"]) {
      console.log("pagamentoForm.submit()", pagamentoForm);
      pagamentoForm.submit();
    }
  })

  const buildRichiestaVersoStarest = () => {
    console.log('_calcolo=', _calcolo)
    const scadenza_formattata = formatScadenza(String(_calcolo.dataScadenza.mese.idDecodifica.id).padStart(2, '0') + "-" + _calcolo.dataScadenza.anno);
    console.log('scadenza_formattata=', scadenza_formattata)
    console.log('idVeicolo=' +  _calcolo)
    if ((_calcolo && _calcolo.importoForzato && _calcolo.idVeicolo === undefined)) {
     console.log("NOOO")
      return (
        {
          "importoForzato": _calcolo.importo.totale.importo,
          "scadenza": scadenza_formattata,
          "mesiValidita": _calcolo.validita,
          "targa": _targa,
          "codiceFiscale": _codiceFiscale,
          "email": email,
          "urlOK": getMainUrl() + getUrlEsitoPagamento(_authMode, Constants.STR_ESITO_OK),
          "urlKO": getMainUrl() + getUrlEsitoPagamento(_authMode, Constants.STR_ESITO_KO),
          "mode": getPaymentMode()
        }
      )
    }

    if (_calcolo && _calcolo.esplicativo && _calcolo.esplicativo === "Importo Fisso Annuo") {
      return (
        {
          "codiceFiscale": _codiceFiscale,
          "codiceTipoVeicolo": _tipoVeicolo,
          "targa": _targa,
          "email": email,
          "urlOK": getMainUrl() + getUrlEsitoPagamento(_authMode, Constants.STR_ESITO_OK),
          "urlKO": getMainUrl() + getUrlEsitoPagamento(_authMode, Constants.STR_ESITO_KO),
          "mode": getPaymentMode()
        }
      )
    }
    console.log("sono arrivato qua")
    return (
      {
        "idVeicolo": _calcolo.esitoCalcoloRegionale ? _calcolo.esitoCalcoloRegionale.idVeicolo.id : _calcolo.idVeicolo,
        "scadenza": scadenza_formattata,
        "mesiValidita": _calcolo.validita,
        "codiceTipoVeicolo": _calcolo.tipoVeicolo ? _calcolo.tipoVeicolo : _tipoVeicolo,
        "codiceFiscale": _codiceFiscale,
        "targa": _targa,
        "email": email,
        "urlOK": getMainUrl() + getUrlEsitoPagamento(_authMode, Constants.STR_ESITO_OK),
        "urlKO": getMainUrl() + getUrlEsitoPagamento(_authMode, Constants.STR_ESITO_KO),
        "mode": getPaymentMode()
      }
    )
  }

  const sendRichiestaPagamento = async (datiRichiesta) => {
    setLoading(true)
    const esitoPrenotazionePagamento = await postPagoTassaPagoPa(datiRichiesta);
    console.log('esitoPrenotazionePagamento=', esitoPrenotazionePagamento)
    if (esitoPrenotazionePagamento === undefined || esitoPrenotazionePagamento.detail !== undefined) {
      console.log('Prenotazione pagamento fallita per richiesta ', datiRichiesta)
      setError(esitoPrenotazionePagamento.detail)
      setLoading(false)
      return
    } 
    setPrenotazionePagamento(esitoPrenotazionePagamento)
    setLoading(false)
  }

  const sendRichiestaPagamentoModelloTre = async (datiRichiesta) => {
    setLoading(true)
    const esitoPrenotazionePagamento = await postPagoTassaPagoPaModelloTre(datiRichiesta);
    console.log('esitoPrenotazionePagamento=', esitoPrenotazionePagamento)
    if (esitoPrenotazionePagamento === undefined || esitoPrenotazionePagamento.detail !== undefined) {
      console.log('Prenotazione pagamento fallita per richiesta ', datiRichiesta)
      setError(esitoPrenotazionePagamento.detail)
      setLoading(false)
      return
    } 
    setUrlStampa(esitoPrenotazionePagamento.stampa)
    setPdfAvviso(true)
    setLoading(false)
  }

  const handleSubmit = () => {
    const request = buildRichiestaVersoStarest();
    console.log('POST verso pagoTassaPagoPa=', request);
    sendRichiestaPagamento(request);
  }

  const handlePagaDopoSubmit = () => {
    const request = buildRichiestaVersoStarest();
    console.log("invio modello 3 risposta", request);
    sendRichiestaPagamentoModelloTre(request)
  }

  const onEmailChanged = (event) => {
    _handleEmailChange(Validator.getValidEmailOrEmptyValue(event.target.value))
    setEmail(event.target.value.toLowerCase())
  }

  const [popoverPagaAdessoOpen, setPopoverPagaAdessoOpen] = useState(false);
  const pagaAdessoRef = useRef(null);

  const togglePopoverPagaAdesso = () => {
    setPopoverPagaAdessoOpen(!popoverPagaAdessoOpen);
  };

  const [popoverPagaDopoOpen, setPopoverPagaDopoOpen] = useState(false);
  const pagaDopoRef = useRef(null);

  const togglePopoverPagaDopo = () => {
    setPopoverPagaDopoOpen(!popoverPagaDopoOpen);
  };

  const [popoverPDFOpen, setPopoverPDFOpen] = useState(false);
  const scaricaPdfRef = useRef(null);

  const togglePopoverPDF = () => {
    setPopoverPDFOpen(!popoverPDFOpen);
  }; 
  

  const showPagaSuccessivamente = () => {
    console.log(pdfAvviso)
    if(pdfAvviso === false) 
       return (
        <Button className="btn btn-primary btn-60" color="primary" icon={false} size="sm" tag="button" 
                onClick={handlePagaDopoSubmit} 
                innerRef={pagaDopoRef}
                disabled={!Validator.isValidEmail(email)}>
             Paga più tardi
        </Button>)
        ;
    else   
       return (
       //<a class="btn btn-primary btn-60" target="_blank" innerRef={scaricaPdfRef} href={urlStampa}>Scarica PDF</a>
       <Button className="btn btn-primary btn-60" color="primary" icon={false} size="sm" tag="button" 
                onClick={(e) => {
                  window.open(urlStampa,"_blank");
                 }}
                innerRef={scaricaPdfRef} >
                Scarica PDF
        </Button>
       );
  }


  //START RENDERING
  if (isLoading === true) { return showProgress(); }
  if(error !== undefined) {return <Container className="px-2 my-2" id="error" tag="section" >
  <Alert color="danger">ATTENZIONE: {error}</Alert>
</Container>}
  if (prenotazionePagamento === undefined) {
    return (
      <Container className="px-2 my-2" id="prenotaPagamento" tag="section">

        {/* STALIGK-834 <h3>Procedi al pagamento di:</h3> */}
        <h3>Importo :</h3>
        <h2><strong>{parseFloat(_calcolo.importo.totale.importo).toFixed(2)}</strong> {_calcolo.importo.totale.divisa.descrizione}</h2>
        {/* STALIGK-834 <p>Stai per essere rendirizzato al nodo regionale pagamenti</p> */}
        <Input
          id="inserisciEmail"
          infoText="*:campo obbligatorio - inserire l'e-mail sulla quale ricevere la ricevuta di pagamento"
          label="* Indirizzo e-mail"
          placeholder="es.: mario@rossi.it"
          value={email}
          type="email"
          onChange={onEmailChanged}
          required
          valid={Validator.isValidEmail(email)}
          invalid={!Validator.isValidEmail(email)}
        />
        <Row>
        <Col md={3} />
        <Col md={3} >
          <Button className="btn btn-primary btn-60" color="primary" icon={false} size="sm" tag="button" 
                  onClick={handleSubmit} 
                  innerRef={pagaAdessoRef}
                  disabled={!Validator.isValidEmail(email)}>
           Paga adesso
          </Button>
          <Popover
          placement="top"
          trigger="hover"
          target={pagaAdessoRef}
          isOpen={popoverPagaAdessoOpen}
          toggle={togglePopoverPagaAdesso}
          >
           <PopoverHeader as="h3">Modalità di pagamento</PopoverHeader>
           <PopoverBody>Verrai reindirizzato al nodo regionale pagamenti PagoPA dove potrai completare il pagamento</PopoverBody>
          </Popover>
        </Col>
        <Col md={3} >
          {showPagaSuccessivamente()} 
          <Popover
          placement="top"
          trigger="hover"
          target={pagaDopoRef}
          isOpen={popoverPagaDopoOpen}
          toggle={togglePopoverPagaDopo}
          >
          <PopoverHeader as="h3">Modalità di pagamento</PopoverHeader>
          <PopoverBody>Verrà generato un modulo di pagamento di PagoPA scaricabile in formato PDF con il quale potrai pagare successivamente</PopoverBody>
          </Popover>
          
          <Popover
          placement="top"
          trigger="hover"
          target={scaricaPdfRef}
          isOpen={popoverPDFOpen}
          toggle={togglePopoverPDF}
          >
          <PopoverHeader as="h3">Modulo di pagamento in formato PDF</PopoverHeader>
          <PopoverBody>Clicca qui per scaricare il modulo di pagamento di PagoPA in formato PDF con il quale potrai pagare successivamente</PopoverBody>
          </Popover>

        </Col>  
        <Col md={3} />
        </Row>
      </Container>
    )
  } else {
    return (
      <div>
        <Modal isOpen={true} popConfirm style={{ maxWidth: "50%" }} className="text-center align-middle">
          <ModalHeader className="text-center align-middle" charCode={215} closeAriaLabel="Close" tag="h4" wrapTag="div" >
            ATTENDERE
          </ModalHeader>
          <ModalBody tag="div">
            <h4>Redirezione verso nodo pagamenti... <br /></h4>
            {showSpinner()}
          </ModalBody>
        </Modal>
        <form id="pagamentoForm" action={prenotazionePagamento.urlAction} method="POST">
          <input type="hidden" name="alias" value={prenotazionePagamento.alias} />
          <input type="hidden" name="importo" value={prenotazionePagamento.importo} />
          <input type="hidden" name="divisa" value={prenotazionePagamento.divisa} />
          <input type="hidden" name="url" value={prenotazionePagamento.url} />
          <input type="hidden" name="url_back" value={prenotazionePagamento.url_back} />
          <input type="hidden" name="urlpost" value={prenotazionePagamento.urlpost} />
          <input type="hidden" name="mac" value={prenotazionePagamento.mac} />
          <input type="hidden" name="identificativoFiscalePagatore" value={prenotazionePagamento.identificativoFiscalePagatore} />
          <input type="hidden" name="tipoPagatore" value={prenotazionePagamento.tipoPagatore} />
          <input type="hidden" name="anagraficaPagatore" value={prenotazionePagamento.anagraficaPagatore} />
          <input type="hidden" name="mail" value={prenotazionePagamento.mail} />
          <input type="hidden" name="urlAction" value={prenotazionePagamento.urlAction} />
          <input type="hidden" name="codTrans" value={prenotazionePagamento.codTrans} />
        </form>
      </div>
    )
  }
}

export default SibaPrenotaPagamento;